module.exports = __webpack_public_path__ + "img/reports.1066355a.png";